import useSWR from "swr";
import { JSON_FETCHER } from "@/components/fetcher";

export type InvoiceSummary = {
  id: string;
  number: string | null;
  created: number;
  total: number;
  currency: string;
  status: "draft" | "open" | "paid" | "uncollectible" | "void";
  hosted_invoice_url: string | null;
  invoice_pdf: string | null;
};

export default function useInvoices(): {
  invoices: InvoiceSummary[];
  isLoading: boolean;
  isError: unknown;
} {
  const { data, error } = useSWR("/web_api/billing/invoices", JSON_FETCHER);

  return {
    invoices: data?.invoices || [],
    isLoading: !(data || error),
    isError: error,
  };
}
